import { useAuthStore } from '@/store/auth';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/logout/')({
  beforeLoad: async ({ context }) => {
    console.debug('[/logout]: Logging out...');

    context.queryClient.clear();
    const authService = useAuthStore.getState().authService;

    if (authService) {
      await authService.signout();
    }

    throw redirect({ to: '/login', search: { redirect: undefined } });
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Log out - OPAZ E-Service Portal',
        },
      ],
    };
  },
});
